<template>
    <div class="[&:not(:hover)]:line-clamp-1 whitespace-pre-line min-w-fit">
            <!-- <div class="[&:not(:hover)]:line-clamp-1"> -->
                {{ nextStepDetails }}
            <!-- </div> -->
        </div>
</template>

<script setup>
import { computed } from 'vue';
import { defineProps, defineEmits, ref, watch } from 'vue';

const props = defineProps([
    'nextStep' 
])
const emit = defineEmits([
    'update-next-step'
])

const initialDetials = computed(() => {
    return props.nextStep.action_notes
})
const nextStepDetails = computed(() => {
    return props.nextStep ? props.nextStep.action_notes : "--"
})


</script>